module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-left": "0px !important"
    },
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 linkTableMediumSmall",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "headers": _vm.headers,
      "pagination": _vm.pagination,
      "search": _vm.search,
      "items": _vm.objLinkedStatus,
      "hide-actions": "",
      "rows-per-page-items": [1000]
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('v-switch', {
          attrs: {
            "label": ""
          },
          on: {
            "click": function($event) {
              return _vm.fncSetStatusLink(props.item.id, props.item.linked)
            }
          },
          model: {
            value: (props.item.linked),
            callback: function($$v) {
              _vm.$set(props.item, "linked", $$v)
            },
            expression: "props.item.linked"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "90%"
          }
        }, [_vm._v(_vm._s(props.item.description))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-3 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requiredMessage",
    attrs: {
      "lg12": ""
    }
  }, [_vm._v("\n\t\t\t\t \n\t\t\t")])], 1)], 1)
},staticRenderFns: []}